export default __webpack_public_path__ + "media/images/icons/calendar-visit-schedule-8fa0233f342967de678d72f30b39f78e.svg";